import * as Storage from "../storage";
import * as Answers from "../survey/answers";

// OJO: Esta funcionalidad solo es aplicable a preguntas de tipo Options. Aplicarla sobre otro tipo de preguntas
// puede traer resultados inesperados.

export const loadQuestionsVisibility = (questionnaire, answers) => {
  const localQuestionsVisibility = Storage.getItem(["survey", "questionsVisibility"]);

  if (localQuestionsVisibility && Object.keys(localQuestionsVisibility) > 0) {
    return localQuestionsVisibility;
  }

  return loadQuestionsVisibilityFromQuestionnaire(questionnaire, answers);
};

// Hace el precargado de la visibilidad de las preguntas de acuerdo a las condiciones de cada una
// Sirve para mostrar, en base a las condiciones iniciales de la encuesta o una sesión anterior, las preguntas visibles y ocultas
export const loadQuestionsVisibilityFromQuestionnaire = (questionnaire, answers) => {
  const visibleQuestions = {};

  for (let dimensionIndex = 0; dimensionIndex < questionnaire.length; dimensionIndex++) {
    visibleQuestions[dimensionIndex] = {};
    const questionKeys = Object.keys(questionnaire[dimensionIndex]["questions"] || {});

    for (let questionIndex = 0; questionIndex < questionKeys.length; questionIndex++) {
      if (!visibleQuestions[dimensionIndex][questionIndex]) {
        const question = questionnaire[dimensionIndex]["questions"][questionIndex];

        if (question["conditions"]) {
          const answer = Answers.getAnswer(answers, dimensionIndex, questionIndex);

          // Se descartan las preguntas cuya condición de respuesta ya fue seleccionada inicialmente, es decir, no se deben ocultar por defecto
          // const conditions = selectConditionBasedOnAnswer(question["conditions"], answer, false);
          var questionsToHide = selectQuestionsToHide(
            question["conditions"],
            answer,
            question["selection"]
          );

          // Van a existir preguntas que deben ocultarse pero que no va a capturar la función anterior
          // Esto debido a que algunas preguntas "when" tendrán, a su vez, sus propias condiciones... Esta función se hace cargo de chequear eso.
          const questionsToHideFromQuestionTree = selectQuestionsToHideFromQuestionTree(
            questionnaire[dimensionIndex]["questions"],
            questionsToHide
          );
          questionsToHide.push(...questionsToHideFromQuestionTree);
          // questionsToHide = [...questionsToHide, ...questionsToHideFromQuestionTree];

          if (questionsToHide) {
            questionsToHide.forEach((questionToHide) => {
              visibleQuestions[dimensionIndex][questionToHide] =
                visibleQuestions[dimensionIndex][questionToHide] || {};
              visibleQuestions[dimensionIndex][questionToHide]["visible"] = false;
            });
          }
        }
        visibleQuestions[dimensionIndex][questionIndex] =
          visibleQuestions[dimensionIndex][questionIndex] || {};
        visibleQuestions[dimensionIndex][questionIndex]["visible"] = true;
      }
    }
  }

  return visibleQuestions;
};

const selectQuestionsToHide = (conditions, answer, selection) => {
  const matchingCondition = selectConditionBasedOnAnswer(conditions, answer, selection);

  if (matchingCondition.length === 0) {
    return [...new Set(conditions.map((condition) => condition["questions"]).flat())];
  }

  const matchingConditionQuestions = matchingCondition[0]["questions"];
  const questionsToHide = new Set();

  conditions.forEach((condition) => {
    if (!condition["when"].includes(answer)) {
      const conditionQuestions = condition["questions"];
      const filteredConditionQuestions = conditionQuestions.filter(
        (conditionQuestion) => !matchingConditionQuestions.includes(conditionQuestion)
      );

      if (filteredConditionQuestions.length > 0) {
        filteredConditionQuestions.forEach(questionsToHide.add, questionsToHide);
      }
    }
  });

  return Array.from(questionsToHide);
};

const selectQuestionsToHideFromQuestionTree = (dimensionQuestions, questionsToHide) => {
  if (questionsToHide.length === 0) {
    return [];
  }

  const questionsToHideFromQuestionTree = [];

  questionsToHide.forEach((questionToHide) => {
    const conditions = dimensionQuestions[questionToHide]["conditions"];
    if (conditions) {
      const mixedConditionsQuestions = conditions.map((condition) => condition["questions"]).flat();

      // Se llama de forma recursiva para recorrer las condiciones a lo largo del árbol de condiciones
      const questionsFromQuestionTreeTraversal = selectQuestionsToHideFromQuestionTree(
        dimensionQuestions,
        mixedConditionsQuestions
      );

      questionsToHideFromQuestionTree.push(
        ...mixedConditionsQuestions,
        ...questionsFromQuestionTreeTraversal
      );
    }
  });

  return questionsToHideFromQuestionTree;
};

export const updateQuestionsVisibility = (
  questionnaire,
  questionsVisibility,
  dimensionIndex,
  questionIndex,
  answers
) => {
  const question = questionnaire[dimensionIndex]["questions"][questionIndex];
  const { conditions, selection } = question;

  if (conditions) {
    const answer = Answers.getAnswer(answers, dimensionIndex, questionIndex);
    const selectedAnswerCondition = selectConditionBasedOnAnswer(conditions, answer, selection)[0];

    // Iteramos sobre TODAS LAS CONDICIONES asociadas a la pregunta
    conditions.forEach((condition) => {
      const questionsAffected = condition["questions"];

      const selectedAnswerQuestionsAffected = selectedAnswerCondition
        ? selectedAnswerCondition["questions"]
        : [];

      // Iteramos sobre TODAS las preguntas afectadas por alguna condicion de la pregunta (questionsaffected) y si se encuentran en el listado asociado a la respuesta
      // seleccionada (selectedanswerquestionsaffected), se muestran; en caso contrario, se ocultan.
      questionsAffected.flat().forEach((questionAffectedIndex) => {
        if (selectedAnswerQuestionsAffected.includes(questionAffectedIndex)) {
          questionsVisibility[dimensionIndex][questionAffectedIndex]["visible"] = true;
        } else {
          questionsVisibility[dimensionIndex][questionAffectedIndex]["visible"] = false;

          const questionsToHideFromQuestionTree = selectQuestionsToHideFromQuestionTree(
            questionnaire[dimensionIndex]["questions"],
            [questionAffectedIndex]
          );

          if (questionsToHideFromQuestionTree) {
            questionsToHideFromQuestionTree.forEach((questionToHide) => {
              questionsVisibility[dimensionIndex][questionToHide]["visible"] = false;
            });
          }
        }
      });
    });
  }
  return questionsVisibility;
};

const selectConditionBasedOnAnswer = (conditions, answer, selection) => {
  return conditions.filter((condition) => {
    const questionsWhen = condition["when"];

    for (const questionWhen of questionsWhen) {
      if (selection === "multiple") {
        const onlySelectedOptions = answer
          ? answer.filter((option) => option["value"]).map((option) => option["name"])
          : [];
        if (onlySelectedOptions.includes(questionWhen)) {
          return true;
        }
      } else {
        if (answer === questionWhen) {
          return true;
        }
      }
    }
    return false;
  });
};
